var map = {
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-1.jpg": "e8e1",
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-2.jpg": "d45e",
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-3.jpg": "5d2d",
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-4.jpg": "7b08",
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-5.jpg": "e68e",
	"./wenskaarten-kerstkaarten-kerst-papette-quotes-thumbnail.png": "6740"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0d4";